// KEATS subscription cart-add workaround v3 — May 27 2026
// v1 (May 26): form-click bypass for PDPs with [name="selling_plan"]
// v2 (May 27): + window.fetch interceptor for Recharge bundle widget POST /cart/add.js
// v3 (May 27): + interceptor for Recharge Subscribe Upsell drawer POST /cart/change.js
//              (drawer pops after one-time add, "Subscribe & save N%" button → /cart/change.js
//               with {line, selling_plan, quantity} → 422 sold out → inline error)
// All paths re-route through Storefront API cartCreate + redirect to checkoutUrl.
// Recharge support ticket filed for root-cause fix; this is the customer-facing unblock.
(function () {
  'use strict';

  // ---------- Path A: form-click bypass ----------
  function handleSubClick(e) {
    var btn = e.target.closest('.Sd_addProduct, button[name="add"], button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    var planEl = form.querySelector('[name="selling_plan"]');
    var sellingPlan = planEl && planEl.value;
    if (!sellingPlan) return;
    var variantEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var variantId = variantEl && variantEl.value;
    var quantity = (qtyEl && parseInt(qtyEl.value, 10)) || 1;
    if (!variantId) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.classList.add('is-loading');
    cartCreateAndRedirect([{
      variantId: variantId,
      sellingPlanId: sellingPlan,
      quantity: quantity,
      attributes: []
    }], function () { btn.classList.remove('is-loading'); });
  }
  document.addEventListener('click', handleSubClick, true);

  // ---------- Path B & C: window.fetch interceptor ----------
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var bodyStr = (init && typeof init.body === 'string') ? init.body : null;

      // Path B: /cart/add.js (bundle widget ATC)
      if (/\/cart\/add\.js(\?|$)/.test(url) && method === 'POST' && bodyStr) {
        var parsed;
        try { parsed = JSON.parse(bodyStr); } catch (_) { return origFetch.apply(this, arguments); }
        var items = (parsed && parsed.items) || [];
        if (items.some(function (i) { return i && i.selling_plan; })) {
          var lines = items.map(function (it) {
            return {
              variantId: String(it.id),
              sellingPlanId: String(it.selling_plan),
              quantity: it.quantity || 1,
              attributes: propertiesToAttributes(it.properties || {})
            };
          });
          return new Promise(function (resolve) {
            cartCreateAndRedirect(lines, function (err) {
              resolve(syntheticResponse(err, items));
            });
          });
        }
      }

      // Path C: /cart/change.js with selling_plan (Subscribe Upsell drawer)
      if (/\/cart\/change\.js(\?|$)/.test(url) && method === 'POST' && bodyStr) {
        var changeParsed;
        try { changeParsed = JSON.parse(bodyStr); } catch (_) { return origFetch.apply(this, arguments); }
        if (changeParsed && changeParsed.selling_plan) {
          var lineIdx = parseInt(changeParsed.line, 10); // 1-indexed in /cart/change.js
          var sellingPlan = String(changeParsed.selling_plan);
          // Need to look up current cart line to get variantId + properties
          return new Promise(function (resolve) {
            origFetch.call(window, '/cart.js', { method: 'GET' })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var line = (cart && cart.items && cart.items[lineIdx - 1]) || null;
                if (!line) {
                  console.error('[KEATS sub bypass v3] /cart/change.js: line not found', { lineIdx, cart });
                  resolve(syntheticResponse(true, []));
                  return;
                }
                var storefrontLine = {
                  variantId: String(line.variant_id || line.id),
                  sellingPlanId: sellingPlan,
                  quantity: changeParsed.quantity || line.quantity || 1,
                  attributes: propertiesToAttributes(line.properties || {})
                };
                cartCreateAndRedirect([storefrontLine], function (err) {
                  resolve(syntheticResponse(err, [line]));
                });
              })
              .catch(function (err) {
                console.error('[KEATS sub bypass v3] /cart.js lookup failed', err);
                resolve(syntheticResponse(true, []));
              });
          });
        }
      }

      return origFetch.apply(this, arguments);
    } catch (e) {
      console.error('[KEATS sub bypass v3] fetch wrapper error', e);
      return origFetch.apply(this, arguments);
    }
  };

  function syntheticResponse(err, items) {
    return new Response(JSON.stringify({ status: err ? 'error' : 'ok', items: items }), {
      status: err ? 500 : 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function propertiesToAttributes(props) {
    var out = [];
    for (var k in props) {
      if (Object.prototype.hasOwnProperty.call(props, k)) {
        out.push({ key: String(k), value: String(props[k]) });
      }
    }
    return out;
  }

  function cartCreateAndRedirect(lines, onError) {
    var linesGql = lines.map(function (l) {
      var attrs = (l.attributes || []).map(function (a) {
        return '{key: ' + JSON.stringify(a.key) + ', value: ' + JSON.stringify(a.value) + '}';
      }).join(', ');
      return '{quantity: ' + (l.quantity || 1) +
        ', merchandiseId: "gid://shopify/ProductVariant/' + l.variantId + '"' +
        ', sellingPlanId: "gid://shopify/SellingPlan/' + l.sellingPlanId + '"' +
        ', attributes: [' + attrs + ']}';
    }).join(', ');
    var q = 'mutation { cartCreate(input: {lines: [' + linesGql + ']}) { cart { checkoutUrl } userErrors { field message } } }';
    origFetch.call(window, '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ query: q })
    }).then(function (r) { return r.json(); }).then(function (d) {
      var cc = d && d.data && d.data.cartCreate;
      var url = cc && cc.cart && cc.cart.checkoutUrl;
      if (url) {
        console.log('[KEATS sub bypass v3] cartCreate ok, redirecting to', url);
        window.location.href = url;
        return;
      }
      console.error('[KEATS sub bypass v3] cartCreate failed', d);
      if (onError) onError(d);
    }).catch(function (err) {
      console.error('[KEATS sub bypass v3] fetch error', err);
      if (onError) onError(err);
    });
  }
})();
